import React, { useEffect } from 'react'
import axios from 'axios'
import ReCAPTCHA from 'react-google-recaptcha'
import Resizer from 'react-image-file-resizer'
import { useSelector, useDispatch } from 'react-redux'
import { analytics } from 'firebase'

import classes from './CardPhoto.module.css'
import AddCardMC from '../../../../images/icon/card.svg'
import AddCardVisa from '../../../../images/icon/card2.svg'
import CardExample from '../../../../images/card2_2_f.png'
import VCExample from '../../../../images/icon/VCExample.png'
import Error from '../../../../images/icon/error.svg'
import cardPhoto from '../../../../redux/stores/CardPhoto/cardPhotoAction'

import {
    fileInputAction, imgAction, noneFileDataAction,
    uploadButtonAction,
    uploadButtonValidationAction
} from '../../../../redux/stores/CardPhoto/actions'

import config from '../../../../config/environment'

import { strings } from '../../../../i18n'
import statusCard from '../../../elements/statusCard'

const reCaptchaRef = React.createRef()

const CardPhoto = () => {
    const state = useSelector(state => state.cardPhoto)
    const dispatch = useDispatch()

    useEffect(() => {
        cardPhoto()
        window.scroll(0, 0)
    }, [])

    analytics().logEvent('open_CardPhotoScreen')
    analytics().setCurrentScreen('CardPhotoScreen')

    const fileInputHandler = async (state, event) => {
        const file = event.target.files[0]

        const fileData = await new Promise(resolve => {
            Resizer.imageFileResizer(file, 1920, 1080, 'JPEG', 80, 0, uri => { resolve(uri) }, 'base64')
        })

        dispatch(fileInputAction(state, fileData))
    }

    const uploadButtonHandler = async (state) => {
        window.scrollTo(0, 0)
        try {
            const { cardNumber, locale, fileData, countryCode } = state

            if (!cardNumber) {
                dispatch(uploadButtonValidationAction(state))
                return;
            }
            if (!fileData) {
                dispatch(uploadButtonValidationAction(state))
                return;
            }

            const captchaToken = await reCaptchaRef.current.executeAsync()

            const body = new FormData()
            body.set('cardNumber', cardNumber)
            body.set('locale', locale)
            body.set('countryCode', countryCode)
            body.set('captchaToken', captchaToken)
            body.append('image', fileData)

            const response = await axios.post(config.backendUrl + '/payment-details/validate-card', body, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })

            dispatch(uploadButtonAction(state, response.data.verificationStatus))

        } catch (error) {
            alert(error.message)
            reCaptchaRef.current.reset()
            return;
        }
    }

    const images = [
        {
            src: CardExample,
            alt: strings('cardPhoto.physicalCard'),
        },
        // {
        //     src: VCExample,
        //     alt: strings('cardPhoto.virtualCard'),
        // }
    ]


    let currentData = new Date()
    currentData = `${currentData.getDate()}.${currentData.getMonth() + 1}.${currentData.getFullYear()}`

    return (
        <div className={classes.main}>
            <div className={classes.information}>
                <h3>{strings('cardPhoto.proof')}</h3>
                <div className={classes.text__card}>
                    {state.cardNumber ? strings('cardPhoto.takePhoto') + state.cardNumber.slice(-4, state.cardNumber.length) : null}
                </div>
                <div className={classes.add__photo}>
                    {state.fileData && state.fileData !== 'File Not Found' ?
                        !state.upload ?
                            <>
                                <div className={classes.wrapper}>
                                    <div style={{ width: 320 }}>
                                        <div className={classes.change__card}
                                            onClick={() => { dispatch(noneFileDataAction(state)) }}>
                                            <img src={Error} alt={'changeCard'} height={44} />
                                        </div>
                                    </div>
                                    <div className={classes.card__wrapper}>
                                        <img src={state.fileData} alt={'fileData'}
                                            className={classes.card} />
                                    </div>
                                </div>
                            </> :
                            <div className={classes.card__wrapper__upload}>
                                <img src={state.fileData} alt={'fileData'}
                                    className={classes.card} />
                            </div>
                        :
                        <label htmlFor={'addCard'}
                            className={state.fileValid ? classes.file__valid : classes.add__card}>
                            <img src={state.scheme === 'mastercard' ? AddCardMC : AddCardVisa}
                                alt={'addCard'} />
                        </label>}
                    <input id={'addCard'} type="file" onChange={event => fileInputHandler(state, event)}
                        onClick={(e) => { e.target.value = '' }} />
                    {state.upload ?
                        <div className={classes.upload__success}>
                            {strings('cardPhoto.verificationStatus')}: {statusCard(state.verificationStatus).toLowerCase()}
                        </div> :
                        <>
                            <div className={classes.button}>
                                <button onClick={() => {
                                    uploadButtonHandler(state)
                                    analytics().logEvent('cardPhoto_click_upload')
                                }}>{strings('cardPhoto.upload')}</button>
                            </div>
                        </>
                    }
                </div>
                <div className={classes.example__wrapper}>
                    <div className={classes.header}>
                        {strings('mobileBuy.modal.photoRequirements')}
                    </div>
                    <div className={classes.description}>
                        {strings('mobileBuy.modal.photoRequirementsDescription', { data: currentData })}
                    </div>
                    <h3>{strings('cardPhoto.examples')}</h3>
                    {images.map((el) => {
                        return (
                            <>
                                <div className={classes.card__example}>
                                    <h5>{el.alt}</h5>
                                    <img src={el.src} alt={el.alt}
                                        onClick={() => { dispatch(imgAction(state, true, el.src, el.alt)) }} />
                                </div>
                                <div className={classes.modal}
                                    style={{ display: state.showModal ? 'block' : 'none' }}>
                                    <div>
                                        <span className={classes.close} onClick={() =>
                                            dispatch(imgAction(state, false, null, null))}>&times;</span>
                                        <img className={classes.modalContent} src={state.src} alt={state.alt} />
                                        <div className={classes.caption}>{state.alt}</div>
                                    </div>
                                </div>
                            </>
                        )
                    })}
                </div>
            </div>
            <ReCAPTCHA
                ref={reCaptchaRef}
                size="invisible"
                sitekey={config.captchaSiteKey}
                style={{ position: 'absolute', top: '20%' }}
            />
        </div>
    )
};

export default CardPhoto
